import { MIME_TYPE_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import type { AxiosInstance } from "axios";

export interface GetFormConfigurationResponse {
  formConfiguration: string;
  etag: string | null;
}

export const fetchFormConfiguration = async (
  api: AxiosInstance,
  formConfigurationId: string,
): Promise<GetFormConfigurationResponse> => {
  return api
    .get<string>(`/form-configurations/${formConfigurationId}/serve`, {
      headers: {
        Accept: MIME_TYPE_JSON,
        "Content-Type": MIME_TYPE_JSON,
      },
    })
    .then((response) => ({
      formConfiguration: response.data,
      etag: response.headers["etag"]?.replace(/"/g, "") ?? null,
    }));
};

export const fetchFormConfigurationTheme = async (
  api: AxiosInstance,
  formConfigurationThemeId: string,
): Promise<string | null> => {
  return api
    .get<string>(`/themes/${formConfigurationThemeId}/serve`, {
      headers: {
        Accept: MIME_TYPE_JSON,
        "Content-Type": MIME_TYPE_JSON,
      },
    })
    .then((response) => response.data);
};
